// Until we upgrade to Typescript 5.5, we need to use this function to filter out null and undefined values
export function filterEmptyDocuments<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return value !== null && value !== undefined;
}
